import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import ProviderStatusForm from "@components/dynamic/ProviderStatusForm";

const ProviderStatusIndex = () => {
  useEffect(() => {
  }, []);


  return (
    <PageContainer
      title="Estado de Cuenta Provedor"
      backUrl="/user/dashboard-accounting"
    >
      <h3>Seleccion un provedor para generar el estado de cuenta.</h3>
      <ProviderStatusForm />

    </PageContainer >
  );
}

export default ProviderStatusIndex;
